<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="dataState" type="card" @tab-click="handleClick">
                <el-tab-pane label="待审核" name='0'></el-tab-pane>
                <el-tab-pane label="已审核" name='1'></el-tab-pane>
            </el-tabs>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="80px">
            <el-form-item label="关键字" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item v-if="dataState == '0' " label="标引时间" prop="indexTime">
                <el-date-picker
                    v-model="searchForm.indexTime"
                    clearable
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-else label="审核时间" prop="auditTime">
                <el-date-picker
                    v-model="searchForm.auditTime"
                    clearable
                    style="width: 100%"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-if="dataState == '0' " label="标引人" prop="createBy">
                <el-select style="width: 100%;" v-model="searchForm.createBy" clearable placeholder="请选择标引人">
                    <el-option
                            v-for="item in applicantList"
                            :key="item.createBy"
                            :label="item.createByName"
                            :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-else label="审核结果" prop="labeState">
                <el-select style="width: 100%;" v-model="searchForm.labeState" clearable placeholder="请选择审核结果">
                    <el-option
                        v-for="item in auditResultList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="text_right p_all1" v-show="dataState == '0'">
            <el-button v-if="hasPermission('converge:mark:markIndex:through')" type="primary"
                       @click="setToexamine('','through')"
                       size="small">批量通过
            </el-button>
            <el-button v-if="hasPermission('converge:mark:markIndex:reject')" @click="setToexamine('','reject')"
                       size="small">
                批量驳回
            </el-button>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                @selection-change="selectionChangeHandle"
                @sort-change="sortChangeHandle"
                size="small" height="100%"
                class="table" ref="multipleTable" row-key='middleId' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="labelName" label="标引名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" sortable label="标引时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="标引人" show-overflow-tooltip>
<!--                <template slot-scope="scope">-->
<!--                    {{ $dictUtils.getDictLabel("purpose_type", scope.row.purpose, '') }}-->
<!--                </template>-->
            </el-table-column>
            <el-table-column prop="labeState" label="标引状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ $dictUtils.getDictLabel("labe_state", scope.row.labeState, '') }}
                </template>
            </el-table-column>
            <el-table-column prop="resourcesName" label="标引资源名" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-link type="primary" @click="view(row)">{{ row.resourcesName }}</el-link>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    min-width="100"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('converge:mark:markIndex:view')" type="text" size="small"
                               @click="view(scope.row)">详情
                    </el-button>
                    <el-button v-if="hasPermission('converge:mark:markIndex:through')" v-show="dataState == '0'"
                               type="text" size="small"
                               @click="setToexamine(scope.row, 'through')">通过
                    </el-button>
                    <el-button v-if="hasPermission('converge:mark:markIndex:reject')" v-show="dataState == '0'"
                               type="text" size="small"
                               @click="setToexamine(scope.row, 'reject')">驳回
                    </el-button>
                    <el-button v-if="hasPermission('converge:mark:markIndex:record')" type="text" size="small"
                               @click="recordData(scope.row)">审核记录
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <set-toexamine ref="setToexamine" @refresh="refreshList(1,1)"></set-toexamine>
        <resource-add-edit-form ref="resourceAddEditForm" @refreshData="refreshList(1,1)"></resource-add-edit-form>
        <audit-records ref="auditRecords"></audit-records>
    </div>
</template>

<script>

import SetToexamine from "@/components/toExamine/setToexamine.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";
import AuditRecords from "@/components/toExamine/auditRecords.vue";

export default {
    name: "toExamine",
    components: {AuditRecords, ResourceAddEditForm, SetToexamine},
    data() {
        return {
            dataState: '0',
            searchForm: {
                keyword: '',
                indexTime:[],
                createStartDate:'',
                createEndDate:'',
                auditTime:[],
                auditStartTime:'',
                auditEndTime:'',
                createBy:'',
                labeState:'',
                current: 1,
                size: 20,
            },
            total: 0,
            applicantList: [],
            auditResultList: [
                {
                    value: 2,
                    label: '已通过'
                },
                {
                    value: 3,
                    label: '已驳回'
                },
            ],
            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherList()
    },

    methods: {
        handleClick() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1,1)
        },

        getOtherList() {
            this.$axios(this.api.academic.resourceslabelResourcesLabelUserList, {}).then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (this.searchForm.indexTime && this.searchForm.indexTime.length != 0) {
                this.searchForm.createStartDate = this.searchForm.indexTime[0]
                this.searchForm.createEndDate = this.searchForm.indexTime[1]
            } else {
                this.searchForm.createStartDate = ''
                this.searchForm.createEndDate = ''
            }
            if (this.searchForm.auditTime && this.searchForm.auditTime.length != 0) {
                this.searchForm.auditStartTime = this.searchForm.auditTime[0]
                this.searchForm.auditEndTime = this.searchForm.auditTime[1]
            } else {
                this.searchForm.auditStartTime = ''
                this.searchForm.auditEndTime = ''
            }
            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData,'indexTime')
            this.$delete(searchData,'auditTime')
            this.loading = true
            this.$axios(this.api.academic.resourceslabelAuditList, {
                ...searchData,
                auditState: this.dataState,
            }).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },
        //排序
        sortChangeHandle (obj) {
            obj.prop = this.getHumpLineName(obj.prop);
            if (obj.order === 'ascending') {
                this.searchForm.orderBy = obj.prop + ' asc'
            } else if (obj.order === 'descending') {
                this.searchForm.orderBy = obj.prop + ' desc'
            } else {
                this.searchForm.orderBy = ''
            }
            this.refreshList(1)
        },
        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        //详情 typeName view详情 edit编辑 toExamineView审核详情
        view(row) {
            this.$refs.resourceAddEditForm.init('view', row.resourcesId, '', row.basicDataId,'',row,'markIndex')
        },

        //审核记录
        recordData(row){
            this.$refs.auditRecords.init(row.id)
        },

        //type through通过 reject驳回
        setToexamine(row, type) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            let url = this.api.academic.resourceslabelAudit
            if (type == 'through') {
                //通过
                this.$refs.setToexamine.init(ids, type, url, {
                    auditState: 2
                })
            } else {
                //驳回
                this.$refs.setToexamine.init(ids, type, url, {
                    auditState: 3
                })
            }
        },
    },
}
</script>

<style scoped>

</style>
